// Disable the angular change detection on requestAnimation frame in order to speed up rendering
(window as any).__Zone_disable_requestAnimationFrame = true;
(window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll'];
